import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import BasicDialog from "../../../components/base/BasicDialog";
import { useProducts } from "../../../services/productsService";
import { ProductPassport } from "../ProductPassport/ProductPassport";

export const ProductPassportWindow = () => {
    const { t } = useTranslation();
    const { productId } = useParams();
    const params = new URLSearchParams();
    if (productId) {
        params.append("id", productId);
    }

    const { data, isLoading, error } = useProducts(params);

    if (isLoading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error || !data?.results?.length) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                }}
            >
                <Typography variant="h4" color="error">
                    {t("products.ProductPassport.errorLoading")}
                </Typography>
            </Box>
        );
    }

    const product = data.results[0];

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100vw",
                padding: 0,
                margin: 0,
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.default",
            }}
        >
            <BasicDialog
                open={true}
                onClose={() => {
                    window.close();
                }}
                titleAlign={"center"}
                contentAlign={"center"}
                showTitle={false}
                title={"test"}
                maxWidth={"lg"}
                showDialogActions
                alwaysFullScreen={true}
            >
                <ProductPassport product={product} />
            </BasicDialog>
        </Box>
    );
};
